package ui.campaign.detailv2.widgets

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import api.ResourceType
import compose.assets.Svg
import compose.assets.svg.Aspect_ratio
import compose.assets.svg.Clock_outline
import compose.assets.svg.MoveResize
import compose.assets.svg.Multimedia
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail_editor__summary_visuals_label
import tools.labelRes
import tools.rememberString
import ui.resource.imageVector
import ui.widget.LazyImage


@Composable
fun CampaignInfoCardVisuals(
    visuals: List<ImplCampaignInfoCard.Visual>,
    onClick: ((id: Long) -> Unit)? = null
) {
    CampaignInfoCardWrapper(
        icon = Svg.Multimedia,
        label = Res.string.layer_top_detail_editor__summary_visuals_label.rememberString(),
    ) {
        visuals.forEach { visual ->
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier.fillMaxWidth()
                    .clickable(onClick != null) {
                        onClick?.invoke(visual.id)
                    }) {
                LazyImage(
                    id = visual.id,
                    alphaBackground = false,
                    modifier = Modifier.height(128.dp)
                        .aspectRatio(visual.width.toFloat() / visual.height.toFloat(), true)

                )
                Column(
                    Modifier.align(Alignment.CenterVertically),
                    verticalArrangement = Arrangement.spacedBy(4.dp)
                ) {
                    Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                        Icon(visual.type.imageVector(), null)
                        Text(visual.type.labelRes.rememberString())
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                        Icon(Svg.MoveResize, null)
                        Text("${visual.width} x ${visual.height}")
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                        Icon(Svg.Aspect_ratio, null)
                        Text(visual.ratio.label)
                    }
                    if (ResourceType.VIDEO == visual.type) {
                        Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                            Icon(Svg.Clock_outline, null)
                            Text(visual.duration.toString())
                        }
                    }
                }
            }
        }
    }
}